import React, { useState } from 'react';
import { CardActions, Grid, Grow, CardMedia, Card, Link, Typography, CardHeader } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

const Block3 = (props) => {

    const { title, subHeader, content, image } = props.value;

    const [eli, setEli] = useState(2);

    const hoverChange = (params) => {
        if (params === 'in') {
            setEli(2)
        } else {
            setEli(1)
        }
    }

    const mdSize = useMediaQuery((theme) => theme.breakpoints.only('md'));

    return (
        <React.Fragment>

            <Grow in={true} style={{ transitionDelay: '50ms' }}>
                <Card
                    elevation={1}
                    onMouseOver={() => hoverChange('in')}
                    onMouseOut={() => hoverChange('out')}
                    sx={{
                        position: 'relative',
                        cursor: "pointer",
                        minHeight: {
                            xs: "600px",
                            sm: "auto"
                        },
                        margin: "10px",
                        width: "100%"
                    }}
                >
                    <CardHeader
                        title={
                            <Typography variant='h1'>{title}</Typography>
                        }
                        subheader={
                            <Typography variant='h2' align='justify'>{subHeader}</Typography>
                        }
                    />

                    <CardMedia
                        component="img"
                        height={mdSize ? "640" : "340"}
                        image={image}

                        onMouseOver={() => hoverChange('in')}
                        onMouseOut={() => hoverChange('out')}
                    />


                    <Grid container item md={12} display="flex"
                        sx={{
                            backgroundColor: "transparent",
                            opacity: ".9",
                            color: "#fff",
                        }}
                    >
                        <Grid container item md={12} alignItems="center" justifyContent="flex-start"
                            sx={{
                                backgroundColor: "transparent",
                                color: "#000",
                                opacity: "1",
                                padding: "10px",
                                margin: "10px"
                            }}
                        >
                            <Typography sx={{ fontSize: "16px", fontWeight: "400" }} align='justify'>{content}</Typography>
                        </Grid>
                    </Grid>

                    <CardActions sx={{ margin: 1 }}>

                    </CardActions>
                </Card>
            </Grow>

        </React.Fragment>
    )
}

export default Block3;